import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ImagemPostosAtendimento from 'assets/img/postosAtendimento.svg';
import InputSelectMultiple from 'components/InputSelectMultiple';
import InputTextArea from 'components/InputTextArea';
import Button from 'components/Button';
import { postosAtendimentoEditar, postosAtendimentoListar } from 'routes/paths';
import { clearErroChange } from 'utils/formUtils';
import { ENUM_PERMISSAO } from 'utils/permissao';
import * as S from '../styles';
import { altImagePostosAtendimento } from 'utils/acessibilidade';
import { openModalConfirmacao } from 'components/Modal/ModalConfirmacao';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { ALERTA, MSG_POSTO_ATENDIMENTO_DELETADO_SUCESSO } from 'utils/consts';
import { fetchDeletarPostoAtendimento } from 'store/fetchActions/fetchPostosAtendimento';

export default function ContainerPostosAtendimento({
  errors,
  control,
  getValues,
  setValue,
  setError,
  optionsServicos,
  onSubmit,
  disabled = false,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [exibirEditar, setExibirEditar] = useState(false);
  const [exibirApagar, setExibirApagar] = useState(false);

  const user = useSelector(state => state.sefaz.userProfile);
  const postoAtendimentoDetalhar = useSelector(state => state.postosAtendimento?.postosAtendimentoDetalhar);

  React.useEffect(() => {
    if (user?.permission.includes(ENUM_PERMISSAO.SUP1101.codigo)) setExibirEditar(true);
    if (user?.permission.includes(ENUM_PERMISSAO.SUP1102.codigo)) setExibirApagar(true);
  }, [user]);

  const handleChange = e => {
    const { name, value } = e.target;
    setValue(name, value);
    clearErroChange(name, value, errors, setError);
  };

  const deletarPostoAtendimento = () => {
    dispatch(fetchDeletarPostoAtendimento(postoAtendimentoDetalhar?.id)).then(() => {
      history.push(postosAtendimentoListar);
      fetchNotificationApp(MSG_POSTO_ATENDIMENTO_DELETADO_SUCESSO, '', ALERTA.SUCESSO);
    });
  };

  return (
    <form>
      <Row>
        <Col xs={24} sm={5} md={5} lg={5} xl={5}>
          <S.Descricao>Para cadastrar um Posto de Atendimento preencha todas as informações solicitadas.</S.Descricao>
          {disabled && (
            <S.ContainButton>
              {exibirEditar && <Button text={'Editar'} clickAction={() => history.push(postosAtendimentoEditar)} />}
              {exibirApagar && (
                <Button
                  text={'Deletar'}
                  clickAction={() => openModalConfirmacao({ funcSuccess: deletarPostoAtendimento })}
                  css={{ corSecundaria: '#ffffff', cor: '#C62828' }}
                />
              )}
            </S.ContainButton>
          )}
          <InputTextArea
            label="* Nome do Posto de Atendimento"
            name="nomePosto"
            errors={errors}
            placeholder={'Nome do Posto de Atendimento'}
            control={control}
            onChange={handleChange}
            maxLength={250}
            rows={2}
            disabled={disabled}
          />
          <InputTextArea
            label="* Endereço"
            name="endereco"
            errors={errors}
            placeholder={'Endereço do Posto de Atendimento'}
            control={control}
            onChange={handleChange}
            maxLength={250}
            rows={2}
            disabled={disabled}
          />
          <InputTextArea
            label="Telefone(s)"
            name="telefone"
            errors={errors}
            placeholder={'Telefone(s) do Posto de Atendimento'}
            control={control}
            onChange={handleChange}
            maxLength={50}
            disabled={disabled}
          />
          <InputTextArea
            label="* Dias e Horários de Atendimento"
            name="diasHorariosAtendimentos"
            errors={errors}
            placeholder={'Dias e Horários de Atendimento'}
            control={control}
            onChange={handleChange}
            maxLength={250}
            disabled={disabled}
          />
          {disabled ? (
            <InputTextArea
              label="* Serviços"
              name="solicitacaoIds"
              errors={errors}
              placeholder={'Serviços do Posto de Atendimento'}
              control={control}
              onChange={handleChange}
              maxLength={250}
              disabled={disabled}
              style={{ height: '100px' }}
              value={postoAtendimentoDetalhar?.postoSolicitacoes?.map(x => x.solicitacao).join(', ')}
            />
          ) : (
            <InputSelectMultiple
              label="* Serviços"
              name="solicitacaoIds"
              errors={errors}
              placeholder={'Serviços do Posto de Atendimento'}
              control={control}
              options={optionsServicos}
              disabled={disabled}
              initialValue={getValues()?.solicitacaoIds || []}
              maxTagCount={10}
            />
          )}
        </Col>
        <Col xs={24} sm={16} md={16} lg={16} xl={16} style={{ margin: 'auto' }}>
          <S.ImagemPostosAtendimento
            data-testid="Imagem Page Postos Atendimento"
            src={ImagemPostosAtendimento}
            alt={altImagePostosAtendimento}
          />
        </Col>
      </Row>
      {!disabled && <Button text={'Salvar'} clickAction={onSubmit} css={{ margin: '7px 0px 7px 7px' }} />}
    </form>
  );
}
